var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66389 1.66597V4.99792",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3278 1.66597V4.99792",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8267 3.33194H4.16493C3.24484 3.33194 2.49896 4.07782 2.49896 4.99791V16.6597C2.49896 17.5798 3.24484 18.3257 4.16493 18.3257H15.8267C16.7468 18.3257 17.4927 17.5798 17.4927 16.6597V4.99791C17.4927 4.07782 16.7468 3.33194 15.8267 3.33194Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49896 8.32986H17.4927",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9917,
    height: 19.9917,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents2);
export default __webpack_public_path__ + "static/media/Events2.d2ea6bc7218f4946304a3422eaa7854c.svg";
export { ForwardRef as ReactComponent };